<template>
    
    <v-list-group class="mb-1 ml-4 mr-4 search"

        prepend-icon="dashboard"
        no-action
        >
        <v-list-tile slot="activator">
            <v-list-tile-title  >{{ groupTitle }}</v-list-tile-title>
        </v-list-tile>
        <SearchRoomMulti class="ml-3" v-on:closeMS="expandMultiAttributeSearch=false"/>
        <!-- <v-layout style="margin-left: 70px; margin-right: 20px;" class="subheading" row justify-space-between @click="expandMultiAttributeSearch=!expandMultiAttributeSearch">
                <v-flex style="opacity: 0.67;">Multi Attribute</v-flex>
                <v-flex class="text-xs-right">
                    <v-icon >
                    {{expandMultiAttributeSearch ? 'arrow_drop_up' : 'arrow_drop_down'}}
                    </v-icon>
                </v-flex>
            </v-layout>
            <SearchRoomMulti class="ml-3" v-if="expandMultiAttributeSearch" v-on:closeMS="expandMultiAttributeSearch=false"/>
       
        <div v-if="!expandAmenities">
            <v-autocomplete
                class="ml-5"                
                ref="autocomplete"
                @change="categoryChanged"
                v-model="selectedCategory"
                autocomplete
                clearable                    
                flat 
                single-line
                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                :items="categories"
                item-text="nameAndID"
                item-value="categoryID"
                label="Room Category"
                :label="catLabel"
                @click="catLabel='Enter Category Name or ID'"
                hide-no-data
                hide-details>
            </v-autocomplete>
        

        
            <v-autocomplete
                class="ml-5"
                
                ref="autocomplete"
                @change="useChanged"
                v-model="selectedUse"
                autocomplete
                single-line
                clearable                    
                flat 
                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                :items="uses"
                item-text="nameAndID"
                item-value="useID"
                label="Room Use"
                :label="useLabel"
                @click="useLabel='Enter Use Name or ID'"
                hide-details>
            </v-autocomplete>
        
            <v-autocomplete
                class="ml-5 mb-4"                
                ref="autocomplete"
                @change="nameChanged"
                v-model="selectedName"
                autocomplete
                single-line
                clearable                    
                flat 
                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                :items="roomNames"
                item-text="name"
                item-value="name"
                label="Room Name"
                :label="roomName"
                @click="roomName='Enter Room Name'"
                hide-details>
            </v-autocomplete>

               
        
            <v-layout style="margin-left: 70px; margin-right: 20px;" class="subheading" row justify-space-between @click="expandAmenities=!expandAmenities">
                <v-flex style="opacity: 0.67;">Room Amenities</v-flex>
                <v-flex class="text-xs-right">
                    <v-icon >
                    {{expandAmenities ? 'arrow_drop_up' : 'arrow_drop_down'}}
                    </v-icon>
                </v-flex>
            </v-layout>
        </div>
        <AmenitiesSearch class="ml-3" v-if="expandAmenities" v-on:closeAS="expandAmenities=false"/>   
        <SearchRoomMulti class="ml-3" v-if="expandMultiAttributeSearch" v-on:closeMS="expandMultiAttributeSearch=false"/>
            -->
    </v-list-group> 
</template>

<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
    import AmenitiesSearch from '@/components/roomAmenities/AmenitiesSearch'
    import SearchRoomMulti from '@/components/search/SearchRoomMulti'

    let SearchRoom = {

        components: { AmenitiesSearch, SearchRoomMulti },

        data() {
            return {
                expandMultiAttributeSearch: false,
                expandAmenities: false,
                catLabel: "Room Category",
                useLabel: "Room Use",
                roomName: "Room Name",
                employee: null,
                selectedUse: null,
                selectedCategory: null,
                selectedName: null,
                groupTitle :    "Room Attributes",
            }
        },

        computed: {

            
            ...mapState({
                categories: state => state.lists.categories,
                uses:       state => state.lists.uses,
                roomNames:  state => state.lists.roomNames
            }),
            
        },

        methods: {
            ...mapActions(['fetchSearchRooms']),

            ...mapMutations([   'setSearchResults',
                                'setLoading',
                                'setSearchTitle',
                                'setSearchSubtitle',
                                'setSearchSort',
                                'setSelectedRoom',
                                'updateSearchResultSidebar',
                                'updateMainSidebar',
                                'setSnackText',
                                'clearSearch',
                                'setSearchExportText',
                            ]),
            
            categoryChanged (value) { 
                // Removes buggy behavior
                if (typeof value === 'object') { 
                    //console.log("Object sent from PI autocomplete blur event.  Do nothing.")
                    return
                }
                if (value) { 
                    // Clear Selected 
                    this.$nextTick(() => {
                        this.selected = null  
                    })                  
                    
                    this.submitSearch({ 'category': value }) 
                    this.setLoading(true)
                }
            },

            useChanged (value) { 
                // Removes buggy behavior
                if (typeof value === 'object') { 
                    //console.log("Object sent from PI autocomplete blur event.  Do nothing.")
                    return
                }
                if (value) { 
                    // Clear Selected 
                    this.$nextTick(() => {
                        this.selected = null  
                    })                  
                    
                    this.submitSearch({ 'use': value }) 
                    this.setLoading(true)
                }
            },

            nameChanged (value) { 
                // Removes buggy behavior
                if (typeof value === 'object') { 
                    //console.log("Object sent from PI autocomplete blur event.  Do nothing.")
                    return
                }
                if (value) { 
                    // Clear Selected 
                    this.$nextTick(() => {
                        this.selected = null  
                    })                  
                    
                    this.submitSearch({ 'name': value }) 
                    this.setLoading(true)
                }
            },


            queryText: function (searchPayload) {
                if (searchPayload["category"]) {
                    let categoryName = this.categories.find((category) => category.categoryID == searchPayload["category"] ).categoryName
                    return "Category: " + categoryName
                }

                if (searchPayload["use"]) {
                    let useName = this.uses.find((use) => use.useID == searchPayload["use"] ).useName
                    return "Use: " + useName
                }

                if (searchPayload["name"]) {
                    //let roomName = this.roomNames.find((name) => name.name == searchPayload["name"] ).roomName
                    let roomName = this.selectedName
                    return "Name: " + roomName
                }

                return JSON.stringify(searchPayload)
            },

            submitSearch(searchPayload) {
                this.clearSearch()
                this.fetchSearchRooms(searchPayload).then((data) => {
                    if (!data || data == "No Rooms Found") {
                        this.setSnackText("No Results Found");  
                        this.setLoading(false)
                        return
                    }

                    // Collapse smaller sites into one site "Other Sites"
                        
                        let newData = JSON.parse(JSON.stringify(data)) // Deep Copy
                        newData.sites = []
                        let otherBuildings = []

                        data.sites.forEach((site) => {
                            
                            // if this site is not Main, Phx, or South, collect all the buildings together into an array.
                            if (site.siteID != '10' && site.siteID != '19' && site.siteID != '108') {
                                site.buildings.forEach((bldg) => {
                                    otherBuildings.push(bldg)
                                })                         
                            } else { 
                                // else just push this site into the return (newData) whole                           
                                newData.sites.push(site)
                            }
                        })

                        // Build the "Other" site
                        if (otherBuildings.length > 0) {
                            newData.sites.push({'siteID': 'Other', 'siteName': 'Other Sites', 'buildings': otherBuildings})
                        }


                    this.setSearchResults(newData) 
                    //this.setSearchResults(data)    // Using this instead will detail out each individual site
                    //this.updateMainSidebar(false)                   

                    

                    const subtitle =    `<div style="background-color: #30302E;color: white;padding: 25px;margin-left: -25px;
                                                margin-top: -25px;">
                                                <div class="headline">${this.queryText(searchPayload)}</div>
                                                <div>Total Area: ${data.areaSum.toLocaleString()}</div>
                                                <div>Bldg Count: ${data.bldgCount.toLocaleString()}</div>
                                                <div>Room Count: ${data.roomCount.toLocaleString()}</div>

                                        `

                    this.setSearchTitle("Room Search")                    
                    this.setSearchExportText(this.queryText(searchPayload))
                    this.setSearchSubtitle(subtitle)              
                    this.updateSearchResultSidebar(true)
                    this.setLoading(false)
                }) 
            },
        }
    }

    export default SearchRoom
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/search/SearchRoom.vue